import VueGtag from 'vue-gtag-next';

const domainToGaIdMap = {
  'app.wiseppc.com': 'G-SQ4T349GP0',
  'dev.wiseppc.com': 'G-38RMHGBFC1',
};

const defaultGaId = 'G-38RMHGBFC1';
const currentDomain = window.location.hostname;

// Экспортируем для доступа в других файлах
export const googleAnalyticsId = domainToGaIdMap[currentDomain] || defaultGaId;

export const isTrackingHost = Object.prototype.hasOwnProperty.call(domainToGaIdMap, currentDomain);

export function setupGoogleAnalytics(app) {
  if (!isTrackingHost) return;

  app.use(VueGtag, {
    property: {
      id: googleAnalyticsId,
    },
    appName: 'WisePPC',
    pageTrackerScreenviewEnabled: true,
    useScreenview: false, // Отключаем screenview в пользу custom pageview
    disableScriptLoad: false, // Автоматически загружать скрипт
  });
}
